@if (isOpen()) {
  <!-- Backdrop with glass effect -->
  <div class="modal-backdrop" animate.enter="backdrop-enter" animate.leave="backdrop-leave" (click)="onBackdropClick()">
    <div class="glass-overlay"></div>
  </div>

  <!-- Modal Panel -->
  <div class="modal-panel" animate.enter="panel-enter" animate.leave="panel-leave">

    <!-- Close Button (absolute positioned) -->
    <app-mat3-button
      variant="icon"
      class="close-btn"
      icon="mdi:arrow-left"
      [iconSize]="24"
      ariaLabel="Close modal"
      (buttonClick)="onCloseClick()">
    </app-mat3-button>

    <!-- Content Area -->
    <div class="modal-content">
      <ng-content></ng-content>
    </div>
  </div>
}